(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ventadetalle', {
            parent: 'entity',
            url: '/ventadetalle',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventadetalle.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventadetalle/ventadetalles.html',
                    controller: 'VentadetalleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventadetalle');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ventadetalle-detail', {
            parent: 'ventadetalle',
            url: '/ventadetalle/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventadetalle.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventadetalle/ventadetalle-detail.html',
                    controller: 'VentadetalleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventadetalle');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ventadetalle', function($stateParams, Ventadetalle) {
                    return Ventadetalle.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ventadetalle',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ventadetalle-detail.edit', {
            parent: 'ventadetalle-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventadetalle/ventadetalle-dialog.html',
                    controller: 'VentadetalleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventadetalle', function(Ventadetalle) {
                            return Ventadetalle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventadetalle.new', {
            parent: 'ventadetalle',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventadetalle/ventadetalle-dialog.html',
                    controller: 'VentadetalleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                comercio: null,
                                ip: null,
                                fecha: null,
                                nroticket: null,
                                esncredito: null,
                                cliente: null,
                                tipofactura: null,
                                operacion: null,
                                descripcion: null,
                                monto: null,
                                cantidad: null,
                                mdepcategoria: null,
								codigomoneda: null,
								categoria: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ventadetalle', null, { reload: 'ventadetalle' });
                }, function() {
                    $state.go('ventadetalle');
                });
            }]
        })
        .state('ventadetalle.edit', {
            parent: 'ventadetalle',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventadetalle/ventadetalle-dialog.html',
                    controller: 'VentadetalleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventadetalle', function(Ventadetalle) {
                            return Ventadetalle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventadetalle', null, { reload: 'ventadetalle' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventadetalle.delete', {
            parent: 'ventadetalle',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventadetalle/ventadetalle-delete-dialog.html',
                    controller: 'VentadetalleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ventadetalle', function(Ventadetalle) {
                            return Ventadetalle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventadetalle', null, { reload: 'ventadetalle' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
